/** Helper de espera assíncrona usado pelos hooks de retry com backoff
 * (HUB-237, CA-06/07/08/16/19) — testável com `vi.useFakeTimers()`. */
export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
